import { ChevronDownIcon, ShoppingCartIcon } from '@sketchnote/icons';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { API } from 'src/api';

import { useSidebarStore } from '../store';

export const SketchnoteLessons = () => {
  const { isSketchnoteLessonOpen, toggleSketchnoteLesson } = useSidebarStore((s) => ({
    isSketchnoteLessonOpen: s.isSketchnoteLessonOpen,
    toggleSketchnoteLesson: s.toggleSketchnoteLesson,
  }));

  const router = useRouter();
  const orgId = router.query?.orgId;
  const mode = router.query?.mode;

  return (
    <section className="text-gray-500 text-sm py-10  border-b">
      <button className="w-full flex justify-between px-12 -ml-2">
        <div className="flex-grow">
          <Link href={`/${mode}/${orgId}/lms/snlessons`}>
            <a>
              <span
                className="flex font-medium text-gray-600"
                role="button"
                onClick={() => {
                  toggleSketchnoteLesson(!isSketchnoteLessonOpen);
                }}
              >
                <span className="block mt-3 mr-5 ml-1 ">
                  <ShoppingCartIcon className="text-base" />
                </span>
                &nbsp;Pre-created lessons
              </span>
            </a>
          </Link>
        </div>
        <div
          className="block pl-6"
          style={{
            transform: isSketchnoteLessonOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
            transition: 'all 0.5s',
          }}
        >
          <ChevronDownIcon wrapperClass="mt-2 pt-4" />
        </div>
      </button>
    </section>
  );
};
